import { StFeatureFlagFlags } from '@/plugins/rollout';
import { createApi } from '@stilingue/st-auth-utils';
import Service from '@/services/Service';
import { error401Handler } from '@/utils/error';

const version = StFeatureFlagFlags.UserLegacyServiceVersionProd.getValue();
const gateway = StFeatureFlagFlags.gatewayProd.getValue();

const afterParser = response => response.data;

export class AccountService extends Service {
  constructor(gateway, version) {
    const api = createApi(`upms-legacy/${version}/account/`, gateway, { error401Handler });
    super(api, { afterParser });
  }

  account(id) {
    return this.find({ url: `${id}` });
  }
}

export default new AccountService(gateway, version);
